import { render, staticRenderFns } from "./xcenter.vue?vue&type=template&id=edd019b2&scoped=true&"
import script from "./xcenter.vue?vue&type=script&lang=js&"
export * from "./xcenter.vue?vue&type=script&lang=js&"
import style0 from "./xcenter.vue?vue&type=style&index=0&id=edd019b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd019b2",
  null
  
)

export default component.exports